import { useState } from 'react';
import { NudosButton, NudosTextInput } from '../../../../../components/NudosComponents';
import { isEmailValid } from '../../../../../utils/formValidations';
import errorMessage from '../../../../../utils/errorMessage';
import { removeAccessToBackofficeForUser } from '../../../../../services/configuration.service';
import { isEditingInThisModuleAllowed } from '../../../../LogisticServices/utils/general.utils';
import './RemoveUserAccessToBackofficeSection.scss';

const RemoveUserAccessToBackofficeSection = ({ updateDataCallback }: { updateDataCallback?: () => void }) => {
  const [email, setEmail] = useState<string>();
  const [loading, setLoading] = useState(false);

  const validEmail = isEmailValid(email || '');
  const emailError = email && !validEmail ? 'Escribe un email válido' : undefined;
  const isButtonDisabled = !validEmail || loading || !isEditingInThisModuleAllowed();

  const removeBackofficeAccess = async () => {
    if (!email || !validEmail) return;
    try {
      setLoading(true);
      await removeAccessToBackofficeForUser(email);
      updateDataCallback && updateDataCallback();
    } catch {
      errorMessage();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="removeUserAccessToBackofficeSection">
      <div className="sectionTitle">Remover accesso al backoffice</div>
      <div className="instructions">
        Se removerá el accesso al backoffice para el usuario con el correo que escribas (debe tener acceso actualmente o
        arrojará error)
      </div>
      <div className="fieldAndButton">
        <NudosTextInput
          componentSize="medium"
          label="Correo"
          placeholder={'nombre@correo.com'}
          isFilled={!!email}
          errorText={emailError}
          handleChange={setEmail}
        />
        <NudosButton
          buttonText="Guardar"
          customWidth="64px"
          customHeight="20px"
          handleClick={removeBackofficeAccess}
          isButtonDisabled={isButtonDisabled}
          isButtonLoading={loading}
        />
      </div>
    </div>
  );
};

export default RemoveUserAccessToBackofficeSection;
